export default {
    data() {
        return {
            originalUrl: window.location.protocol + '//' + window.location.host + window.location.pathname,
            formData: new FormData(),
            infinitePage: 2,
            infiniteReset: false,
            homeDelivery: this.homeDeliveryRoute,
            selectedFilters: {
                range: [],
                brand: [],
                specialist: [],
                season: [],
                fuel: [],
                wet: [],
                manufacturer_approved: [],
                vehicle_type: [],
                load_index: [],
                speed: [],
                order_by: ''
            },
            baseUrl: '',
            speedParam: '',
            loadParam: '',
            isDisabled: false
        };
    },
    created() {
        this.baseUrl = this.originalUrl;
    },
    methods: {
        loadUrlParams() {
            let vm = this;
            if(window.location.search != '') {
                var searchParams = window.location.search.split('?');
                var splitParams = searchParams[1].split('&');

                _.forEach(splitParams, function( param) {
                    var params = param.split('=');

                    var filterType = params[0];
                    var filterValue = params[1];

                    //If home_delivery_prices parameter exists, set homeDelivery to true for use with preselecting route
                    if(filterType == 'home_delivery_prices') {
                        vm.homeDelivery = true;
                    }

                    if(filterType == 'load_index') {
                        //Store load index parameter for use with reset filters
                        vm.loadParam = filterValue;
                    }

                    if(filterType == 'speed') {
                        //Store speed parameter for use with reset filters
                        vm.speedParam = filterValue;
                    }
                    else {
                        filterValue = filterValue.charAt(0).toUpperCase() + params[1].slice(1);
                    }

                    //order_by is not an array, so can't use push, so we just change value instead.
                    if(filterType == 'order_by') {
                        vm.selectedFilters[filterType] = [filterValue.toLowerCase()];
                    }

                    if(filterType != 'home_delivery_prices' && filterType != 'order_by') {
                        vm.selectedFilters[filterType].push(filterValue == 'Rft' ? 'RFT' : filterValue);
                    }
                });

                if(vm.loadParam != '' || vm.speedParam != '') {
                    vm.baseUrl += '?';
                    let loadParamUrl = vm.loadParam != '' ? 'load_index=' + vm.loadParam : '';
                    let speedParamUrl = vm.speedParam != '' ? 'speed=' + vm.speedParam : '';
                    vm.baseUrl += loadParamUrl;
                    vm.baseUrl += loadParamUrl != '' ? '&' : '';
                    vm.baseUrl += speedParamUrl;
                }
            }
        },
        loadFormData() {
            let vm = this;
            var formattedFilters = JSON.parse(JSON.stringify(this.selectedFilters));
            var count = 0;
            var pushStateUrl = '';
            vm.formData = new FormData();

            _.forEach(formattedFilters, function( filter, filterType ) {
                //checks to see if filterType is order_by (sorting), if so do not append as array.
                if(filterType != 'order_by') {
                    _.forEach(filter, function( filterValue) {
                        // add [] to the filterType string, for the formData input to be an array
                        vm.formData.append(filterType + '[]', filterValue);

                        //Append filterType and filterValue to pushStateUrl, ready to be pushed to the url
                        pushStateUrl += (count == 0 ? '?' : '&') + filterType + '=' + filterValue;
                        count++;
                    });
                }
                else {
                    if(filter != '') {
                        vm.formData.append(filterType, filter);

                        //Append filterType and filterValue to pushStateUrl, ready to be pushed to the url
                        pushStateUrl += (count == 0 ? '?' : '&') + filterType + '=' + filter;
                        count++;
                    }
                }
            });

            if(vm.homeDelivery == true)
            {
                pushStateUrl += (pushStateUrl == '' ? '?' : '&') + 'home_delivery_prices=yes';
                vm.formData.append('home_delivery_prices', vm.homeDelivery);
            }
            else {
                vm.formData.delete('home_delivery_prices');
            }

            //Appends pushStateUrl to the URL.
            history.pushState({}, '', vm.originalUrl + pushStateUrl.toLowerCase());
        },
        selectFilter(home_delivery_prices, sortOrder = null) {
            // This function is ran when selecting a filter, changing the sort order, checking tyre availability and when toggling the route.

            //Toggle global loading component
            this.emitter.emit('isLoading', true);
            //Disables filters whilst loading
            this.isDisabled = true;

            //If sortOrder != null then we are changing the sort, so we need to change the order_by item in selectedFilters.
            if(sortOrder != null)
            {
                this.selectedFilters['order_by'] = [sortOrder];
            }

            //update homeDelivery flag
            this.homeDelivery = home_delivery_prices;

            //Now run the loadFormData function, so the formData is updated with any newly applied filters or sorting options.
            this.loadFormData();

            let vm = this;
            axios.post('/ajax/apply_filters', vm.formData)
            .then(response => {
                //Toggle global loading component
                this.emitter.emit('isLoading', false);
                //Enables filters now loading has finished
                vm.isDisabled = false;

                if(typeof(response.data.featured_top_spot) != 'undefined') {
                    vm.updatedFeaturedTopSpot = response.data.featured_top_spot;
                }
                else {
                    vm.updatedFeaturedTopSpot = null;
                }

                if(typeof(response.data.top_choices) != 'undefined') {
                    vm.updatedTopChoices = response.data.top_choices;
                }
                else {
                    vm.updatedTopChoices = null;
                }

                if(typeof(response.data.featured_tyres) != 'undefined') {
                    vm.updatedFeaturedTyres = response.data.featured_tyres;
                }

                vm.updatedTotalTyres = response.data.total_tyres;
                vm.updatedTyres = response.data.tyres;
                vm.updatedFilters = response.data.filters;

                //Getting updated fitting availability
                this.updateAllTyreFittingAvailability();

                //emit updated steps globally so steps component receives new route.
                this.emitter.emit('stepsUpdated', response.data.current_route);

                //Refresh tooltips
                setTimeout(() => {
                    this.emitter.emit('refreshTooltips');
                  }, "2000");

                //reset infinite scroll, and sets page back to 2.
                vm.infiniteReset = !vm.infiniteReset;
                vm.infinitePage = 2;
            })
            .catch(error => {
                console.error("There was an error!", error);
            });
        },
        resetFilters() {
            let vm = this;

            //empties the filters, setting selectedFilters to the initial emptyFilters object
            _.forEach(this.selectedFilters, function(value, key) {
                if(key == 'order_by') {
                    vm.selectedFilters[key] = '';
                } else {
                    vm.selectedFilters[key] = [];

                    if(key == 'speed' && vm.speedParam != '') {
                        vm.selectedFilters[key].push(vm.speedParam);
                    }
                    else if(key == 'load_index' && vm.loadParam != '') {
                        vm.selectedFilters[key].push(vm.loadParam);
                    }
                }
            });

            //update url without any additional filters applied
            history.pushState({}, '', this.baseUrl.toLowerCase());

            //apply filters again now that filters are reset
            this.selectFilter(this.homeDelivery);
        },
        routeToggled: function(value) {
            //value has to be 1 (not true) prior to this due to backend requirement.. so i make true now.
            this.homeDelivery = (value === 1 ? true : false);

            //Empty basket products once route has been changed
            if(this.updatedBasket.products) {
                if(Object.keys(this.updatedBasket.products).length > 0) {
                    console.log('emptied basket');
                    this.updatedBasket.products.splice(0);
                    this.emitter.emit('basketEmptied');
                    this.emitter.emit('updateBasket', this.updatedBasket);
                }
            }

            this.selectFilter(this.homeDelivery);
        },
        getTyreRangeTyres(home_delivery_prices, rangeId, brandId, sizes) {
            this.emitter.emit('isLoading', true);
            let vm = this;
            var pushStateUrl = '';
            var formData = new FormData();
            var url = '/get-tyre-range-tyres/' + rangeId + '/' + brandId;

            if(home_delivery_prices == true)
            {
                pushStateUrl += (pushStateUrl == '' ? '?' : '&') + 'home_delivery_prices=yes';
                formData.append('home_delivery_prices', home_delivery_prices);
            }
            else {
                formData.delete('home_delivery_prices');
            }

            vm.homeDelivery = home_delivery_prices;

            var count = 0;
            _.forEach(sizes, function(value, key) {
                if(value != '') {
                    pushStateUrl += (count == 0 ? '?' : '&') + key + '=' + value;
                    formData.append('filters[' + key + ']', value);
                    count++;
                }
            });

            //Appends pushStateUrl to the URL.
            history.pushState({}, '', vm.originalUrl + pushStateUrl.toLowerCase());

            axios.post(url, formData)
            .then(response => {
                vm.$emit('tyresUpdated', response.data.tyres);
                vm.updatedTyres = response.data.tyres;
            })
            .catch(error => {
                console.error("There was an error!", error);
            })
            .finally(response => {
                this.emitter.emit('isLoading', false);
            });

        },
        handleInfiniteScroll($state) {
            let vm = this;

            axios.post('/update-tyres/' + vm.infinitePage, vm.formData)
            .then(response => {
                vm.updatedTyres.push(...response.data.tyres);
                vm.infinitePage++;
                vm.$nextTick(() => {
                    vm.$root.initTooltip()
                    //Getting updated fitting availability
                    vm.updateAllTyreFittingAvailability();
                });
                $state.loaded();
            })
            .catch(error => {
                console.error("There was an error!", error);
                $state.error();
            });
        },
        updateAllTyreFittingAvailability() {
            if(this.updatedPostcode != null) {
                let vm = this;
                var st_code_form_data = new FormData();

                if(typeof(this.updatedFeaturedTopSpot) != 'undefined' && vm.updatedFeaturedTopSpot?.st_code)
                {
                    st_code_form_data.append('st_codes[]', vm.updatedFeaturedTopSpot.st_code);
                }

                if(typeof(this.updatedTopChoices) != 'undefined')
                {
                    _.forEach(this.updatedTopChoices, function(tyre) {
                        st_code_form_data.append('st_codes[]', tyre.st_code);
                    });
                }

                if(typeof(this.updatedFeaturedTyres) != 'undefined')
                {
                    _.forEach(this.updatedFeaturedTyres, function(tyre) {
                        st_code_form_data.append('st_codes[]', tyre.st_code);
                    });
                }

                _.forEach(this.updatedTyres, function(tyre) {
                    st_code_form_data.append('st_codes[]', tyre.st_code);
                });

                axios.post('/ajax/get_tyres_earliest_fitting', st_code_form_data)
                .then(response => {
                    //update existing tyres with new fitting availability
                    var fittingAvailability = response.data;

                    //Featured Top Spot
                    if(typeof(vm.updatedFeaturedTopSpot) != 'undefined' && vm.updatedFeaturedTopSpot?.id) {
                        _.forEach(fittingAvailability, function(updatedTyre) {
                            if(updatedTyre.id == vm.updatedFeaturedTopSpot.id) {
                                vm.updatedFeaturedTopSpot.fitting_today = updatedTyre.fitting_today;
                                vm.updatedFeaturedTopSpot.fitting_tomorrow = updatedTyre.fitting_tomorrow;
                                vm.updatedFeaturedTopSpot.earliest_fitting_date = updatedTyre.earliest_fitting_date;
                            }
                        });
                    }

                    //More Top Choices
                    if(typeof(vm.updatedTopChoices) != 'undefined') {
                        _.forEach(vm.updatedTopChoices, function(originalTyre1) {
                            _.forEach(fittingAvailability, function(updatedTyre1) {
                                if(updatedTyre1.id == originalTyre1.id)
                                {
                                    originalTyre1.fitting_today = updatedTyre1.fitting_today;
                                    originalTyre1.fitting_tomorrow = updatedTyre1.fitting_tomorrow;
                                    originalTyre1.earliest_fitting_date = updatedTyre1.earliest_fitting_date;
                                }
                            });
                        });
                    }

                    //Featured Tyres
                    if(typeof(vm.updatedFeaturedTyres) != 'undefined') {
                        _.forEach(vm.updatedFeaturedTyres, function(originalTyre) {
                            _.forEach(fittingAvailability, function(updatedTyre) {
                                if(updatedTyre.id == originalTyre.id)
                                {
                                    originalTyre.fitting_today = updatedTyre.fitting_today;
                                    originalTyre.fitting_tomorrow = updatedTyre.fitting_tomorrow;
                                    originalTyre.earliest_fitting_date = updatedTyre.earliest_fitting_date;
                                }
                            });
                        });
                    }

                    //Tyres
                    _.forEach(vm.updatedTyres, function(originalTyre) {
                        _.forEach(fittingAvailability, function(updatedTyre) {
                            if(updatedTyre.id == originalTyre.id)
                            {
                                originalTyre.fitting_today = updatedTyre.fitting_today;
                                originalTyre.fitting_tomorrow = updatedTyre.fitting_tomorrow;
                                originalTyre.earliest_fitting_date = updatedTyre.earliest_fitting_date;
                            }
                        });
                    });
                });
            }
        },
    },
    computed: {
        defaultTyreSort: function() {
            return this.selectedFilters.order_by == '' ? 'price_asc' : this.selectedFilters.order_by;
        }
    }
};
